import type { AnyAction } from '@reduxjs/toolkit';
import { FetchClientScopesRoutine } from '../routines';
import type { IClientScopesState } from '../interfaces';

export const initialState: IClientScopesState = {
  isFetching: false,
  data: [],
  error: null,
};

export const clientScopesReducer = (
  state: IClientScopesState = initialState,
  action: AnyAction,
): IClientScopesState => {
  switch (action.type) {
    case FetchClientScopesRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
        error: null,
      };
    case FetchClientScopesRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case FetchClientScopesRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
